import React from 'react';
import styled from 'styled-components';


// here I used transition: all because I really want every of these attributes to have transition,
// and typing every attribute separating with comma, doesnt make sense
const StyledMessage = styled.div<{
  type: 'error' | 'success',
  isVisible: boolean | undefined,
}>`
  padding: ${({ isVisible }) => (isVisible ? '10px' : 0)};
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  height: ${({ isVisible }) => (isVisible ? 'auto' : 0)};
  transform: translateX(${({ isVisible }) => (isVisible ? 0 : '-300px')});
  color: ${({ theme }) => theme.colors.white};
  border-radius: 5px;
  background-color: ${({ theme, type, isVisible }) => ((type === 'success' && isVisible) ? theme.colors.darkBlue : theme.colors.lightCoral)};
  transition: all 300ms ease-in-out;
  width: 100%;
  box-shadow: 6px 6px rgba(0,0,0,0.1);
  z-index: 1;
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.extraSmall}) {
    width: 500px;  
  }
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.large}) {
    bottom: -15px;
    width: 100%;
  }
`;

interface MessageProps {
  type: 'error' | 'success',
  isVisible: boolean | undefined,
  children?: string,
}

const Message = ({
  type,
  isVisible,
  children = undefined,
}: MessageProps) => (
  <StyledMessage
    type={type}
    isVisible={isVisible}
  >
    {children}
  </StyledMessage>
);

export default Message;
